










































































































































import { Component, Vue, Prop, Watch} from 'vue-property-decorator'
import router from '@/router'
import Search from '@/components/public/Search.vue'
import buyApi from '@/api/buyApi'
import cartsApi from '@/api/cartsApi'

@Component({
  components: {
    Search
  }
})
export default class ChoiceShops extends Vue {
  public lockSpinning?: boolean = false;
  private res: any = {
    channelList: {
      businessResourceProviceRespVO: [
        // {
        //   businessResouceStoreRespVOS: [
        //     {
        //       cityCode: 5031,
        //       cityName: '成都市',
        //       code: 'W031',
        //       coinType: 'GOLDCOINS',
        //       name: '环球中心店1',
        //       payCoins: 212,
        //       resourceStoreStatusEnum: 'NO_STATUS',
        //       tradeUnitName: 'SKU'
        //     }, {
        //       cityCode: 543,
        //       cityName: '成都市',
        //       code: 'W031',
        //       coinType: 'GOLDCOINS',
        //       name: '环球中心店2',
        //       payCoins: 21,
        //       resourceStoreStatusEnum: 'NO_STATUS',
        //       tradeUnitName: 'SKU'
        //     }
        //   ],
        //   proviceCode: 512,
        //   proviceName: '四川省'
        // },
        // {
        //   businessResouceStoreRespVOS: [
        //     {
        //       cityCode: 123331,
        //       cityName: '成都市',
        //       code: 'W031',
        //       coinType: 'SILVERCOINS',
        //       name: '环球中心店31',
        //       payCoins: 2323323,
        //       resourceStoreStatusEnum: 'NO_STATUS',
        //       tradeUnitName: 'SKU'
        //     }, {
        //       cityCode: 1233,
        //       cityName: '成都市',
        //       code: 'W031',
        //       coinType: 'SILVERCOINS',
        //       name: '环球中心店43',
        //       payCoins: 3123,
        //       resourceStoreStatusEnum: 'NO_STATUS',
        //       tradeUnitName: 'SKU'
        //     }, {
        //       cityCode: 2454,
        //       cityName: '西昌市',
        //       code: 'W031',
        //       coinType: 'GOLDCOINS',
        //       name: '环球中心店r2',
        //       payCoins: 123323,
        //       resourceStoreStatusEnum: 'NO_STATUS',
        //       tradeUnitName: 'SKU'
        //     }, {
        //       cityCode: 345,
        //       cityName: '上海市',
        //       code: 'W031',
        //       coinType: 'GOLDCOINS',
        //       name: '环球中心店21',
        //       payCoins: 212,
        //       resourceStoreStatusEnum: 'NO_STATUS',
        //       tradeUnitName: 'SKU'
        //     }, {
        //       cityCode: 123,
        //       cityName: '哥谭市',
        //       code: 'W031',
        //       coinType: 'SILVERCOINS',
        //       name: '环球中心店43',
        //       payCoins: 3121,
        //       resourceStoreStatusEnum: 'NO_STATUS',
        //       tradeUnitName: 'SKU'
        //     }
        //   ],
        //   proviceCode: 5141,
        //   proviceName: '湖北省'
        // },

        // {
        //   businessResouceStoreRespVOS: [
        //     {
        //       cityCode: 5031,
        //       cityName: '成都市',
        //       code: 'W031',
        //       coinType: 'GOLDCOINS',
        //       name: '环球中心店43',
        //       payCoins: 212,
        //       resourceStoreStatusEnum: 'NO_STATUS',
        //       tradeUnitName: 'SKU'
        //     }
        //   ],
        //   proviceCode: 5122,
        //   proviceName: '湖南省'
        // }
      ],
      proviceNum: 14,
      resouceId: 1
    },
  }
  private resouceId: string = ''

  private req: any = {
    citysList: [],
    storeCodes: [],  //添加购物车时的code
    searchStr: '',
    filterList: [],
  }

  @Watch('req.citysList')
  onChangeCitysList(newVal: any[], oldVal: string){
    this.req.storeCodes= [];
    newVal.map(item => {
      this.req.storeCodes.push(item.code)
    })
  }

  private checkType: any = {
    indeterminate: false,
    checkAll: false,
    checkArr: []
  }

  private coinType: string = ''
  private filters: any[] = []
  private channelType: number = null
  private arrLength: number = 0
  private checkItem: any[] = []
  private createOrderStatus: boolean = false

  public mounted() {
    this.getList()
  }

  // 获取列表
  private getList() {
    buyApi.choiceChannel({
      resouceId: this.$route.query.id,
      storeName: this.req.searchStr || '',
      uniqueKey:sessionStorage.getItem('uniqueKey')
    }).then((res) => {
      if (res.code === 200) {
        this.res.channelList = res.data
        this.req.searchStr = ''
        this.req.citysList = []
        let arr = res.data.businessResourceProviceRespVO
        arr.forEach((v: any, i: any) => {
          let checkItem: any[] = []
          let obj = {
            channel: v,
            indeterminate: false,
            checkAll: false,
            code: i,
            checkItemType: false,
            checkItem: checkItem
          }
          this.filters.push(obj)
        });
        this.channelType = this.filters[0].channel.proviceCode
        this.coinType = this.filters[0].channel.businessResouceStoreRespVOS[0].coinType
        this.arrLength = this.filters[0].channel.businessResouceStoreRespVOS.length
      }
    })
  }

  // 点击列表 获取右边内容
  protected filtersItem(item: any) {
    this.channelType = item.proviceCode
    this.arrLength = item.businessResouceStoreRespVOS.length
    this.coinType = item.businessResouceStoreRespVOS[0].coinType
  }

  // 搜索
  protected search(str: any) {
    this.filters = []
    this.req.searchStr = str
    this.getList()
  }

  protected onChange(e: any, item: any, channel: any) {
    if (e.target.checked) {
      item.checkItem.push(channel)
    } else {
      const index = item.checkItem.indexOf(channel)
      item.checkItem.splice(index, 1)
    }
    if (item.checkItem.length === this.arrLength) {
      item.checkAll = true
    } else {
      item.checkAll = false
    }
  }

  // 点击单个设置状态
  protected checkStatus(checkedList: any, item: any, channel: any) {
    // console.log(item.channel.businessResouceStoreRespVOS.length)
    // console.log(this.arrLength)
    // console.log('单个的', item.channel.businessResouceStoreRespVOS)
    // console.log('11', checkedList)
    // checkedList.forEach((v: any, i: any) => {

    // });
    // console.log(channel)
    // item.checkItemType = !item.checkItemType
    // // console.log('2222', item.checkItemType)
    // if (item.checkItemType) {
    //   item.checkItem.push(item)
    // } else {
    //   let index = item.checkItem.indexOf(item)
    //   item.checkItem.splice(index, 1)
    // }
    // console.log(item.checkItem)
    // if (item.checkItem.length === this.arrLength) {
    //   item.checkAll = true
    // } else {
    //   item.checkAll = false
    // }
  }

  // 全选按钮
  protected onCheckAllChange(e: any, item: any) {
    item.checkAll = e.target.checked
    const arr: any = []
    if (item.checkAll) {
      item.channel.businessResouceStoreRespVOS.forEach((v: any) => {
        if (v.resourceStoreStatusEnum === 'NO_STATUS') {
          arr.push(v)
        }
      });
      arr.forEach((v: any) => {
        if (this.req.citysList.indexOf(v) === -1) {
          this.req.citysList.push(v)
        }
      });
      return
    } else {
      item.channel.businessResouceStoreRespVOS.forEach((v: any) => {
        const index = this.req.citysList.indexOf(v)
        this.req.citysList.splice(index, 1)
      });
    }
  }

  // 计算价格
  get totalPrice() {
    let allPrice = 0
    this.req.citysList.forEach((item: any, index: any) => {
      allPrice = allPrice * 1 + item.payCoins * 1
    });

    return allPrice.toFixed(2)
  }

  // 锁定库存
  public locked(data?: any,callback?: ()=>void) {
      buyApi.locked(data).then((res)=>{
        if(res.code==200 && res.data.orderLockStatusEnum == 1){
          callback ? callback() : '';
        } else {
          setTimeout(() => {
            this.locked(data,callback); 
          }, 1000)
        }
      })
  }

  // 下单
  protected buy() {
    if (this.createOrderStatus) {
      return
    }
    
    this.createOrderStatus = true
    if (this.req.citysList.length <= 0) {
      this.$warning({
        title: '提示',
        content: '请选择渠道后再提交订单',
      });
      this.createOrderStatus = false;
      return
    }
    buyApi.buy({
      channels: this.req.citysList,
      resouceId: this.res.channelList.resouceId,
      orderCommitEnum: 'SHOPING',
      operType: 1,
      storeCodes:this.req.storeCodes,
      uniqueKey:sessionStorage.getItem('uniqueKey')
    }).then((res) => {
     this.createOrderStatus = false
      if (res.code === 200 && res.data) {
        this.lockSpinning = true;
        this.locked({orderCode: res.data.orderCode,  uniqueKey:sessionStorage.getItem('uniqueKey')},() => {
            const step = '4'
            router.push({ name: 'buy', query: { step, id: this.res.channelList.resouceId, stepStatus: this.$route.query.stepStatus, tradeSize: this.$route.query.tradeSize, orderCode: res.data.orderCode } })
        })
      } else {
        this.$message.warning(res.msg)
      }
    })
  }

  // 添加到购物车
  protected addCart() {
    if (this.createOrderStatus) {
      return
    }
    this.createOrderStatus = true
    if (this.req.citysList.length <= 0) {
      this.$warning({
        title: '提示',
        content: '请选择渠道后再提交订单',
      });
      this.createOrderStatus = false;
      return
    }
    buyApi.addCarts({
      channels: this.req.citysList,
      resouceId: this.res.channelList.resouceId,
      operType: 1,
      storeCodes: this.req.storeCodes,
      uniqueKey:sessionStorage.getItem('uniqueKey')
    }).then((res) => {
      this.createOrderStatus = false
      if (res.code === 200) {
        this.getCarts()
        router.push({ name: 'carts' })
      } else {
        this.$message.warning(res.msg)
      }
    })
  }

  // 获取购物车
  protected getCarts() {
    if (localStorage.getItem('token')) {
      cartsApi.getCartsList({
      }).then((res) => {
        if (res.code === 200) {
          let cartsLenth = res.data.length
          this.$store.commit('changeCartsAmount', cartsLenth)
        }
      })
    }
  }
}
